import React from "react";
import { Button } from "antd";
import "./style.scss";

const DSOButton = ({
  hidden,
  disabled,
  htmlType = "button",
  type = "",
  className = "",
  btnType = "",
  onClick,
  leftIcon,
  rightIcon,
  text,
  size = "small",
  logoIcon,
}) => (
  <Button
    hidden={hidden}
    disabled={disabled}
    htmlType={htmlType}
    type={type}
    className={`btn ${className} ${btnType}`}
    onClick={() => onClick && onClick()}
    size={size}
  >
    <div className="btn-inner-wrapper ">
      {/*<div className="social-media-icon"></div>*/}

      {leftIcon && (
        <div className={`btn-inner-icon left-icon-wrapper ${btnType === "back" ? "mr-2" : ""}`}>
          <img src={leftIcon} alt="" />
        </div>
      )}

      <div style={{ display: "flex", alignItems: "center", gap: ".5rem" }}>
        {logoIcon && <img src={logoIcon} alt="" style={{ width: "20px" }} />}
        <div className={`button-text-wrp ${btnType}`}>{text}</div>
      </div>

      {rightIcon && (
        <div className={`btn-inner-icon right-icon-wrapper`}>
          <img src={rightIcon} alt="" />
        </div>
      )}
    </div>
  </Button>
);

export default DSOButton;
